import {
    Component,
    ComponentInterface,
    Prop,
    h,
    Host,
} from "@stencil/core";
import { Choice } from "../../../../../../utils/backend/reply-parsed";

@Component({
    tag: "c-form-radio",
    styleUrl: "c-form-radio.scss",
})

export class CFormRadio implements ComponentInterface {
    @Prop() elements: Choice[];
    @Prop() formName: string;
    @Prop() germanTitle?: string;
    @Prop() theme?: string;

    render() {
        return (
            <Host>
                <div class="btn-group" role="radiogroup">
                    <label
                        class="radio-group"
                        innerHTML={this.formName}
                        data-german={this.germanTitle}
                    />
                    {this.elements.map((choice, index) => {
                        return (
                            <div class={`form-check ${this.theme ? this.theme : ""}`} key={index}>
                                <input
                                    id={choice.title}
                                    type="radio"
                                    name="buttonGroup"
                                    innerHTML={``}
                                    value={choice.title}
                                    data-german={choice.german}
                                />
                                <label
                                    htmlFor={choice.title}
                                    data-german={choice.german}
                                    innerHTML={choice.title}
                                />
                            </div>
                        );
                    })}
                </div>
            </Host>
        );
    }
}
